<ng-container *ngFor="let item of items">
    <kui-card *ngIf="show[item.key]">
        <kui-card-body>
            <h5>{{ item.title }}</h5>
            <p>{{ item.description }}</p>
            <button *ngFor="let button of item.buttons; let f = first;"
                kui-button
                [color]="f ? 'primary' : 'secondary'"
                class="mr-1 mt-1"
                (click)="button.action()">{{button.text}}</button>
        </kui-card-body>
    </kui-card>
</ng-container>